const differentiators = [
  {
    icon: 'ri-ruler-2-line',
    title: '30+ Precision Measurements',
    desc: 'Most tailors take 10–15 measurements. We take 30+, mapping every curve, proportion, and posture detail of your unique body.',
  },
  {
    icon: 'ri-home-smile-line',
    title: 'We Come to You',
    desc: 'Our master tailors travel to homes and offices across Massachusetts — premium bespoke tailoring without leaving your space.',
  },
  {
    icon: 'ri-time-line',
    title: '55+ Years of Experience',
    desc: 'Our master tailors have spent decades honing their craft. That level of expertise simply cannot be replicated or rushed.',
  },
  {
    icon: 'ri-palette-line',
    title: '5,000+ Fabric Options',
    desc: 'From Italian wools to Egyptian cottons — our fabric library is one of the largest available in all of New England.',
  },
  {
    icon: 'ri-star-line',
    title: 'Truly Bespoke Construction',
    desc: 'No templates, no shortcuts. Every pattern is drafted specifically for your body from scratch using old-world techniques.',
  },
  {
    icon: 'ri-handshake-line',
    title: 'Relationship-Based Service',
    desc: 'We remember your measurements, style preferences, and fabric choices. Your tailor knows you — and that makes all the difference.',
  },
];

const testimonials = [
  {
    name: 'James M.',
    location: 'Wellesley, MA',
    initial: 'J',
    rating: 5,
    text: 'I have been going to Custom Clothiers for over 15 years. My suits always get compliments — the fit is unlike anything I could find off the rack. Worth every penny.',
    image: 'https://public.readdy.ai/ai/img_res/64f3463930714dce0ddf829a71094746.jpg',
  },
  {
    name: 'Richard T.',
    location: 'Newton, MA',
    initial: 'R',
    rating: 5,
    text: 'They made my wedding suit and I could not have been happier. The entire process was seamless, the fabric was incredible, and the fit was absolutely perfect.',
    image: 'https://readdy.ai/api/search-image?query=handsome%20American%20man%20in%20his%20early%2040s%20wearing%20ivory%20cream%20wedding%20suit%20with%20silk%20boutonniere%20smiling%20broadly%20in%20warm%20sunlit%20garden%20setting%20portrait%20photography%20Massachusetts%20outdoor%20ceremony%20natural%20light%20relaxed%20expression&width=200&height=200&seq=test-richard-0326&orientation=squarish',
  },
  {
    name: 'David K.',
    location: 'Boston, MA',
    initial: 'D',
    rating: 5,
    text: 'As someone who wears suits daily for work, I need clothing that performs. Custom Clothiers delivered a suit that looks sharp at 8 AM and still looks sharp at 8 PM.',
    image: 'https://readdy.ai/api/search-image?query=young%20sharp-looking%20executive%20businessman%20in%20his%20mid-30s%20wearing%20fitted%20navy%20pinstripe%20suit%20white%20shirt%20confident%20professional%20smile%20headshot%20portrait%20boston%20financial%20district%20Massachusetts%20daytime%20outdoor%20bright%20natural%20light%20clean%20background&width=200&height=200&seq=test-david-0327&orientation=squarish',
  },
];

const ExpertiseDifferentiatorsSection = () => {
  return (
    <>
      {/* Differentiators with side image */}
      <section className="py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-center">
            {/* Image */}
            <div className="relative rounded-3xl overflow-hidden w-full h-[640px]">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20bespoke%20master%20tailor%20presenting%20a%20large%20open%20fabric%20sample%20book%20filled%20with%20fine%20Italian%20wool%20swatches%20to%20an%20elegantly%20dressed%20male%20client%20in%20a%20luxury%20tailoring%20showroom%20both%20examining%20navy%20and%20charcoal%20suiting%20fabrics%20together%20warm%20amber%20light%20wooden%20display%20shelves%20stacked%20with%20fabric%20bolts%20blurred%20background%20premium%20clothing%20boutique%20Massachusetts%20editorial%20photography&width=900&height=1280&seq=diff-elite-0328&orientation=portrait"
                alt="What makes Custom Clothiers different — fabric consultation Massachusetts"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent"></div>
              <div className="absolute bottom-8 left-8 right-8 bg-black/70 backdrop-blur-md border border-[#C4A962]/30 rounded-2xl p-5">
                <p className="text-[#C4A962] text-xs font-bold tracking-widest uppercase mb-2">Client Rated</p>
                <div className="flex items-center gap-2">
                  <div className="flex gap-1">
                    {[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-[#C4A962] text-sm"></i>)}
                  </div>
                  <span className="text-white font-bold text-sm">127+ Five-Star Reviews</span>
                </div>
              </div>
            </div>

            {/* Content */}
            <div>
              <p className="text-[#C4A962] font-semibold tracking-widest uppercase text-sm mb-5">
                Why Choose Us
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5 leading-tight">
                What Makes Us Different
              </h2>
              <p className="text-gray-500 text-lg mb-10">
                The reasons our clients return year after year — and why they consistently send their friends and colleagues to us.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {differentiators.map((d) => (
                  <div
                    key={d.title}
                    className="p-5 rounded-2xl border border-gray-100 bg-[#F9F6F0] hover:border-[#C4A962]/30 transition-all"
                  >
                    <div className="w-11 h-11 flex items-center justify-center bg-[#C4A962]/15 rounded-xl mb-4">
                      <i className={`${d.icon} text-[#C4A962] text-lg`}></i>
                    </div>
                    <h3 className="text-sm font-bold text-gray-900 mb-2">{d.title}</h3>
                    <p className="text-gray-500 text-xs leading-relaxed">{d.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-28 bg-[#111111]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="text-[#C4A962] font-semibold tracking-widest uppercase text-sm mb-4">
              Client Stories
            </p>
            <h2 className="text-4xl font-bold text-white mb-5">Clients Who Trust Us</h2>
            <p className="text-gray-400 text-lg max-w-xl mx-auto">
              Over 127 five-star reviews and counting. Here is what a few of our clients say.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.map((t) => (
              <div key={t.name} className="bg-white/5 border border-white/10 rounded-3xl p-8 hover:border-[#C4A962]/30 transition-all">
                <div className="flex items-center gap-1 mb-6">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#C4A962] text-base"></i>
                  ))}
                </div>
                <p className="text-gray-300 leading-relaxed mb-8 text-base italic">
                  &ldquo;{t.text}&rdquo;
                </p>
                <div className="flex items-center gap-4 border-t border-white/10 pt-6">
                  <div className="w-14 h-14 rounded-full overflow-hidden bg-[#C4A962]/20 flex-shrink-0 flex items-center justify-center">
                    <img
                      src={t.image}
                      alt={t.name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        const target = e.currentTarget as HTMLImageElement;
                        target.style.display = 'none';
                        const parent = target.parentElement;
                        if (parent) {
                          parent.innerHTML = `<span class="text-[#C4A962] font-bold text-xl">${t.initial}</span>`;
                        }
                      }}
                    />
                  </div>
                  <div>
                    <p className="font-bold text-white">{t.name}</p>
                    <p className="text-gray-400 text-sm">{t.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ExpertiseDifferentiatorsSection;
